export const easings: {
  name: string;
  cubicBezier: string;
}[] = [
  {
    name: 'Linear',
    cubicBezier: '0, 0, 1, 1'
  },
  {
    name: 'Ease',
    cubicBezier: '0.25,0.1,0.25,1'
  },
  {
    name: 'EaseIn',
    cubicBezier: '0.42,0,1,1'
  },
  {
    name: 'EaseOut',
    cubicBezier: '0,0,0.58,1'
  },
  {
    name: 'EaseInOut',
    cubicBezier: '0.42,0,0.58,1'
  },
  {
    name: 'easeInSine',
    cubicBezier: '0.61, 1, 0.88, 1'
  },
  {
    name: 'easeOutSine',
    cubicBezier: '0.61, 1, 0.88, 1'
  },
  {
    name: 'easeInOutSine',
    cubicBezier: '0.37, 0, 0.63, 1'
  },
  {
    name: 'EaseInQuad',
    cubicBezier: '0.11, 0, 0.5, 0'
  },

  {
    name: 'EaseOutQuad',
    cubicBezier: '0.5, 1, 0.89, 1'
  },

  {
    name: 'EaseInOutQuad',
    cubicBezier: '0.45, 0, 0.55, 1'
  },
  {
    name: 'EaseInCubic',
    cubicBezier: '0.32, 0, 0.67, 1'
  },
  {
    name: 'EaseOutCubic',
    cubicBezier: '0.33, 1, 0.68, 1'
  },
  {
    name: 'EaseInOutCubic',
    cubicBezier: '0.65, 0, 0.35, 1'
  },
  {
    name: 'EaseInQuart',
    cubicBezier: '0.5, 0, 0.75, 0.4'
  },
  {
    name: 'EaseOutQuart',
    cubicBezier: '0.25, 1, 0.5, 1'
  },
  {
    name: 'EaseInOutQuart',
    cubicBezier: '0.76, 0, 0.24, 1'
  },
  {
    name: 'EaseInQuint',
    cubicBezier: '0.64, 0, 0.78, 0.6'
  },
  {
    name: 'EaseOutQuint',
    cubicBezier: '0.22, 1, 0.36, 1'
  },
  {
    name: 'EaseInOutQuint',
    cubicBezier: '0.83, 0, 0.17, 1'
  },
  {
    name: 'EaseInExpo',
    cubicBezier: '0.7, 0, 0.84, 0.57'
  },
  {
    name: 'EaseOutExpo',
    cubicBezier: '0.16, 1, 0.3, 1'
  },
  {
    name: 'EaseInOutExpo',
    cubicBezier: '0.87, 0, 0.13, 1'
  },
  {
    name: 'EaseInCirc',
    cubicBezier: '0.55, 0, 1, 0.45'
  },
  {
    name: 'EaseOutCirc',
    cubicBezier: '0, 0.55, 0.45, 1'
  },
  {
    name: 'EaseInOutCirc',
    cubicBezier: '0.85, 0, 0.15, 1'
  },
  {
    name: 'EaseInBack',
    cubicBezier: '0.36, 0, 0.66, -0.56'
  },
  {
    name: 'EaseOutBack',
    cubicBezier: '0.34, 1.56, 0.64, 1'
  },
  {
    name: 'EaseInOutBack',
    cubicBezier: '0.68, -0.6, 0.32, 1.6'
  },
  {
    name: 'FastOutLinearIn',
    cubicBezier: '0.4, 0.0, 1.0, 1.0'
  },
  {
    name: 'Friction',
    cubicBezier: '0.2, 0.0, 0.2, 1.0'
  }
];
